import { useState } from "react";
import { useAuth } from "../../../../hooks/AuthContext";

import { Grid, Box } from "@mui/material";
import ButtonVoltar from "../../../../components/Botoes/ButtonVoltar";
import DadosBasicos from "../../../../components/Cadastro/DadosBasicos";
import { ButtonCustom } from "../../../../components/Botoes/Button";
import { desativarConta } from "../../../../api/ContaCliente/index";
import useAlert from "../../../../hooks/useAlert";
import useStyles from "./styles";
import { Alert, AlertTitle } from "@mui/material";
import { Titulo } from "../../../../components";

const MinhaConta = ({ handlerCancelEdit }) => {
  const { user, signOut } = useAuth();
  const classes = useStyles();
  const { showAlertSuccess, showAlertError } = useAlert();
  const [isLoading, setIsLoading] = useState(false);

  async function deletaUsuario(event) {
    event.preventDefault();
    setIsLoading(() => true);
    try {
      let response = await desativarConta(user.id);

      if (response?.data?.errorMessage)
        throw new Error(response.data.errorMessage);

      showAlertSuccess("Removemos o seu cadastro do nosso banco de dados.");

      setTimeout(() => {
        signOut();
      }, 1500);
    } catch (error) {
      console.error(error.message);
      showAlertError(`Ops, algo deu errado: ${error.message} - R5YF`);
    } finally {
      setTimeout(() => {
        setIsLoading(() => false);
      }, 2000);
    }
  }

  return (
    <Box className={classes.root}>
      <Grid container className={classes.container}>
        {/* Cabeçalho */}
        <Grid item xs={12} className={classes.header}>
          <Box display="flex" alignItems="center" mb={2}>
            <ButtonVoltar handleVoltar={handlerCancelEdit} mostraTexto={true} />
          </Box>
          <Titulo variant="h5" className={classes.title}>
            Minha conta
          </Titulo>
        </Grid>

        {/* Conteúdo principal */}
        <Grid item xs={12}>
          <Grid item sm={12} md={12} lg={12}>
            <Alert severity="warning">
              <AlertTitle>Atenção</AlertTitle>
              Informamos que, de acordo com as diretrizes do Banco Central, não
              é possível realizar a exclusão de sua conta caso haja operações
              vinculadas. De acordo com as diretrizes do Banco Central, temos a
              obrigação de manter registros completos de todas as operações
              realizadas em nossa plataforma, inclusive os dados
              pessoais dos clientes envolvidos. Essas informações são essenciais
              para o cumprimento das regulamentações e relatórios obrigatórios.
            </Alert>
          </Grid>

          <Grid
            item
            sm={12}
            sx={{
              flexDirection: "row",
              display: "flex",
              justifyContent: "flex-end !important",
              width: "100% !important",
              ml: 0,
              mt: 2,
            }}
          >
            <ButtonCustom
              typeButton="primary"
              variant="error"
              size="small"
              onClick={deletaUsuario}
              loading={isLoading}
            >
              Deletar minha conta
            </ButtonCustom>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MinhaConta;
